const ICONS: Record<string, string> = {
  'standard-order': '🛒',
  'place-an-order': '🛒',
  'catalog': '📖',
  'catalog-qa': '📖',
  'delivery': '🚚',
  'booking': '📅',
  'payment': '💳',
  'escalation': '🛎️',
  'assets': '📎',
}

/** Emoji for a skill/workflow catalog key; a neutral default for unmapped keys. */
export function capabilityIcon(key: string): string {
  const k = key.toLowerCase()
  for (const [needle, icon] of Object.entries(ICONS)) {
    if (k.includes(needle)) return icon
  }
  return '🧩'
}
